import type { BuildPresentationProps } from '@features/lci-report/subdomains/visitation/utils/build-presentation';
import type { Slide } from '@features/powerpoint';
import { sectionTitleSlideV2 } from '@features/lci-report/slides/shared/section-title-slide-v2';
import {
  salesLiftSummaryChartSlideV2,
  salesLiftSummaryTableSlideV2,
  contributionMetricsSummarySlideV2,
} from '@features/lci-report/slides/sales-attribution/v2';

export const salesAttributionSlidesV2 = (
  props: BuildPresentationProps,
  slideMaster: string
): Slide[] => {
  if (!props.salesSummary) return [];

  return [
    ...(props.customFields.includedSlides.salesAttribution.titleSlide
      ? [sectionTitleSlideV2('Sales Lift')]
      : []),
    ...(props.customFields.includedSlides.salesAttribution.summary
      ? [
          salesLiftSummaryChartSlideV2({
            slideMaster,
            overallSalesMetrics: props.salesSummary,
            iroas: props.calculatedFields.incrementalReturnOnAdSpend ?? 0,
          }),
        ]
      : []),
    ...(props.customFields.includedSlides.salesAttribution.summaryTable
      ? [
          salesLiftSummaryTableSlideV2({
            slideMaster,
            overallSalesMetrics: props.salesSummary,
            excludedRows: ['controlSalesRate'],
            keyTakeaways: props.customFields.rsaSummaryTable,
            rsaOverallResults: props.customFields.rsaOverallResults,
          }),
        ]
      : []),
    ...(props.customFields.includedSlides.salesAttribution.contributionMetrics
      ? [
          contributionMetricsSummarySlideV2({
            slideMaster,
            overallSalesMetrics: props.salesSummary,
            metric: 'total',
            title: 'Combined',
            keyTakeaways: props.customFields.cmOverall,
          }),
          contributionMetricsSummarySlideV2({
            slideMaster,
            overallSalesMetrics: props.salesSummary,
            metric: 'inStore',
            title: 'In-Store',
            keyTakeaways: props.customFields.cmInStore,
          }),
          contributionMetricsSummarySlideV2({
            slideMaster,
            overallSalesMetrics: props.salesSummary,
            metric: 'online',
            title: 'Online',
            keyTakeaways: props.customFields.cmOnline,
          }),
        ]
      : []),
  ];
};
